const setTitle = (title) => {
  document.title = title;
};

export { setTitle };
